import { Aluno } from '@/domain/entities/aluno.entity'
import { formatBrDate } from '@/utils/formatting/dateMask'
import { formatMoney } from '@/utils/formatting/money'

const setStatus = (status: string) =>
  ({
    Aguardando: 'Aguardando',
    pending: 'Aguardando',
    reproved: 'Reprovado',
    canceled: 'Cancelado',
    approved: 'Aprovado',
    in_processing: 'Em processo',
  })[status]

export const formatStudent = (data: Aluno) => {
  return {
    Nome: data.alunonome,
    CPF: data.alunocpf,
    'Data de Nascimento': data?.alunonascimento
      ? formatBrDate(data.alunonascimento as unknown as string)
      : 'Não cadastrado',
    Email: data.email || 'Não cadastrado',
    Endereço: data.endereco,
    CEP: data.cep,
    'Termos de uso': data.accepted_terms ? 'Aceito' : 'Não aceito',
    conheceu: data.conheceu,
    'Renda familiar': data?.family_income
      ? formatMoney(`${data.family_income / 100}`)
      : 'Não cadastrado',

    'Nome do responsável': data.responsavelnome,
    'CPF do Responsável': data.responsavelcpf,
    'Email do Responsável': data.responsavelemail,
    'Data de Nascimento do responsável': data?.responsavelnascimento
      ? formatBrDate(data.responsavelnascimento as unknown as string)
      : 'Não cadastrado',
    Telefone: data.responsaveltelefone,
    'Telefone 2': data.responsaveltelefone2,
    Status: setStatus(data.status),
    'Última Escola': data.ultimaescola,

    'Data do cadastro': data?.logdata
      ? formatBrDate(data.logdata as unknown as string)
      : 'Não cadastrado',
    'Última atualização': data?.updated_at
      ? formatBrDate(data.updated_at)
      : 'Não cadastrado',
  }
}
